// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"12":"e69191ec","585":"67a23b41"}[chunkId] + ".js";
};